import { Box, Center, Text } from "@chakra-ui/react";

function isSameDayOrLater(date1 : Date, date2 : Date) {
    // Strip the time components from both dates
    const strippedDate1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
    const strippedDate2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
  
    // Compare the stripped dates
    return strippedDate1 >= strippedDate2;
  }

function isYesterdayOrEarlier(date1 : Date, date2 : Date) {

    const strippedDate1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
    const strippedDate2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
  
    return strippedDate1 < strippedDate2;
  }
  

const DateBox = ({date,activeDate,onClick,hasEvent}: {
    date:Date;
    activeDate:Date|null;
    onClick:() => void;
    hasEvent?: boolean;
}) => {
    const monthsOfYear = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const daysOfWeek = [
        'SUN',
        'MON',
        'TUE',
        'WED',
        'THU',
        'FRI',
        'SAT',
    ]
    const isActive = activeDate !== null && 
        activeDate.getMonth() === date.getMonth() &&
        activeDate.getDate() === date.getDate()

    return <Box w='50px' px="10px" 
    cursor={isYesterdayOrEarlier(date, new Date()) ? 'not-allowed' : "pointer"} onClick={() => (isSameDayOrLater(date, new Date())) ? onClick() : {}}
    
    >
        <Text variant='subtle' fontSize='xs'
            textAlign='center' color={isActive ? "#171C22" : hasEvent ? "#374147" : "#a9b2bc"}

        >{daysOfWeek[date.getDay()]}</Text>
        <Center
            w='28px' h='28px'
            borderRadius='16px'
            bg={isActive ? '#171C22' : 'transparent'}
        >
            <Text variant='subtle' fontSize='lg'
                textAlign='center' 
                color={isActive ? "white" : hasEvent ? "#374147" : "#a9b2bc"}
                lineHeight='22px'
            >{date.getDate()}</Text>
        </Center>
        <Text variant='subtle' fontSize='xs'
            textAlign='center' color={isActive ? "#171C22" : hasEvent ? "#374147" : "#a9b2bc"}
        >{monthsOfYear[date.getMonth()]}</Text>
    </Box>
}

export default DateBox